import React, { useState } from 'react';
import SEOHead from '../components/SEOHead';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Chip from '@mui/material/Chip';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const categories = {
	nl: [
		{
			icon: '🛒',
			title: 'Boodschappen',
			saving: 'Bespaar €100–€250/mnd',
			color: '#16a34a',
			tips: [
				{ title: 'Kies huismerken', body: 'Albert Heijn Huismerk, Lidl of Aldi producten kosten 30–50% minder dan A-merken. Kwaliteitsverschil is vaak minimaal.' },
				{ title: 'Maak een boodschappenlijst', body: 'Impulsaankopen kosten gemiddeld €40–€80 per maand extra. Plan je maaltijden een week vooruit en schrijf alleen wat je nodig hebt.' },
				{ title: 'Gebruik Picnic of Crisp', body: 'Online boodschappen doen voorkomt impulsaankopen. Picnic en Crisp bieden ook lage prijzen door hun directe inkoopmodel.' },
				{ title: 'Koop seizoensgebonden groente en fruit', body: 'Seizoensproducten zijn 2–3x goedkoper dan uit het buitenland geïmporteerd fruit of groente buiten het seizoen.' },
				{ title: 'Check de acties bij Lidl en Aldi', body: 'Lidl Plus-app en Aldi-app geven extra kortingen. Door actieproducten te combineren kun je snel 20–30% besparen.' },
				{ title: 'Vermijd voorverpakte groenten', body: 'Een zakje gesneden paprika kost soms 2x zoveel als een hele paprika. Kleine moeite, groot verschil over een jaar.' },
			],
		},
		{
			icon: '👕',
			title: 'Kleding',
			saving: 'Bespaar €50–€150/mnd',
			color: '#7c3aed',
			tips: [
				{ title: 'Koop tweedehands via Vinted of Marktplaats', body: 'Merkkleding voor een fractie van de prijs. Een Levi\'s spijkerbroek van €100 vind je op Vinted al voor €15–€30.' },
				{ title: 'Gebruik de 30-dagenregel', body: 'Wil je iets kopen? Wacht 30 dagen. Als je het dan nog wilt, koop het. Dit elimineert bijna alle impulsaankopen.' },
				{ title: 'Shop buiten het seizoen', body: 'Winterjassen in april, zomerjurkjes in september — vaak 50–70% korting bij de uitverkoop.' },
				{ title: 'Repareer in plaats van weggooien', body: 'Een schoenmaker kost €10–€20 en geeft je schoenen 2–3 jaar extra leven. Veel goedkoper dan nieuwe schoenen.' },
				{ title: 'Defnoo en H&M bewuste collecties', body: 'Zoek kwaliteitsbasics bij merken die langer meegaan. €50 voor een T-shirt dat 5 jaar mee gaat is goedkoper dan €15 dat elk jaar versleten is.' },
			],
		},
		{
			icon: '⚡',
			title: 'Energiecontracten',
			saving: 'Bespaar €50–€200/mnd',
			color: '#d97706',
			tips: [
				{ title: 'Vergelijk via Energie.nl of Gaslicht.com', body: 'Jaarlijks overstappen kan €200–€600 per jaar schelen. Gebruik vergelijkingssites en sluit een contract af als de tarieven laag zijn.' },
				{ title: 'Kies een variabel contract bij dalende prijzen', body: 'Als energieprijzen dalen, profiteer je direct bij een variabel contract. Volg de markt via nieuws of Gaslicht.com.' },
				{ title: 'Zet de thermostaat 1 graad lager', body: '1 graad lager = ~6% minder gasverbruik. Van 21 naar 19 graden scheelt al snel €15–€30 per maand.' },
				{ title: 'LED-verlichting en zuinige apparaten', body: 'LED gebruikt 80% minder stroom dan gloeilampen. Een energielabel A-wasmachine vs. label D scheelt €60–€100 per jaar.' },
				{ title: 'Sluit ventilatieopeningen en isoleer', body: 'Tochtstrips (€5–€15) en vloerisolatie kunnen je gasrekening met 10–15% verlagen. Terugverdientijd: enkele maanden.' },
				{ title: 'Zonnepanelen laten installeren', body: 'Gemiddelde terugverdientijd van zonnepanelen is 7–9 jaar, daarna gratis stroom. Vraag offertes op via ZonnepanelenDelen.nl.' },
			],
		},
		{
			icon: '🏦',
			title: 'Spaarrekening met hoge rente',
			saving: 'Verdien €50–€500/jaar extra',
			color: '#0891b2',
			tips: [
				{ title: 'Vergelijk via Raisin.nl', body: 'Raisin biedt toegang tot Europese spaarrekeningen met hogere rentes. Denk aan 2–3% rente terwijl de grote Nederlandse banken 0,5–1% geven.' },
				{ title: 'NIBC Direct of Bunq', body: 'NIBC Direct biedt soms hogere spaarrentes dan ABN, ING of Rabobank. Bunq Easy Savings geeft ook gemiddeld hogere rentes.' },
				{ title: 'Spreid over meerdere banken (DGS)', body: 'Het depositogarantiestelsel dekt €100.000 per persoon per bank. Spreid grote bedragen om altijd gedekt te zijn.' },
				{ title: 'Gebruik een spaarrekening voor noodfonds', body: 'Houd 3–6 maanden vaste lasten op een aparte spaarrekening. De rente laat dit noodfonds langzaam groeien.' },
				{ title: 'Vergelijk ook Scalable Capital en Trade Republic', body: 'Trade Republic biedt 3–3,5% op saldo dat niet belegd is — hoger dan de meeste spaarrekeningen en gratis toegankelijk.' },
			],
		},
		{
			icon: '📱',
			title: 'Telefoon & Internet',
			saving: 'Bespaar €20–€80/mnd',
			color: '#0284c7',
			tips: [
				{ title: 'Stap over naar een sim-only abonnement', body: 'Sim-only abonnementen beginnen vanaf €5/mnd. Als je telefoon werkt, waarom dan €35–€55 betalen voor een toestelplan?' },
				{ title: 'Vergelijk via Bellen.com of Mobiel.nl', body: 'Vergelijkingssites laten zien waar je de beste deal krijgt. Overstappen kost een half uurtje en levert soms €20/mnd op.' },
				{ title: 'Kies een low-cost provider', body: 'Ben, Simpel, Youfone en Lebara gebruiken dezelfde masten als de grote providers maar zijn €10–€25 per maand goedkoper.' },
				{ title: 'Koop een refurbished telefoon', body: 'Een gerenoveerde iPhone van Renewd of Back Market kost 30–50% minder dan nieuw, met garantie. Milieuvriendelijk én goedkoper.' },
				{ title: 'Combineer internet en TV', body: 'Providers geven vaak kortingen bij bundelpakketten. Check Odido, Ziggo en KPN-bundelacties — soms €15–€25 korting per maand.' },
			],
		},
		{
			icon: '🚗',
			title: 'Transport',
			saving: 'Bespaar €50–€300/mnd',
			color: '#dc2626',
			tips: [
				{ title: 'Overweeg de auto te delen via SnappCar', body: 'Een auto die stil staat kost geld. Verhuur hem via SnappCar als je hem niet gebruikt en verdien €200–€500 per maand terug.' },
				{ title: 'Fiets of OV voor ritten onder 10 km', body: 'De auto rijden kost inclusief afschrijving al snel €0,30–€0,40 per km. Fietsen is gratis en houdt je fit.' },
				{ title: 'Carpool naar werk', body: 'Carpoolen met één collega halveert je brandstofkosten. Via BlaBlaCar of een intern systeem is het eenvoudig te organiseren.' },
				{ title: 'Vergelijk autoverzekeringen jaarlijks', body: 'Via Independer of Pricewise kun je honderden euro\'s per jaar besparen door over te stappen van autoverzekering.' },
				{ title: 'Rij zuiniger met eco-rijden', body: 'Minder gas bij het optrekken, motor uitzetten bij stilstand — dit scheelt snel 10–15% op je brandstofverbruik.' },
			],
		},
		{
			icon: '📺',
			title: 'Abonnementen',
			saving: 'Bespaar €30–€100/mnd',
			color: '#9333ea',
			tips: [
				{ title: 'Doe een abonnement-audit', body: 'Bekijk je bankafschriften van de afgelopen 3 maanden. Veel mensen betalen voor abonnementen die ze nauwelijks gebruiken (gym, streaming, apps).' },
				{ title: 'Deel accounts met familie', body: 'Netflix, Spotify en Disney+ bieden familieplannen. Kosten delen met gezinsleden of vrienden kan €5–€15/mnd besparen per persoon.' },
				{ title: 'Roteer streamingdiensten', body: 'Heb je elke dienst tegelijk echt nodig? Neem 1–2 maanden Netflix, dan Videoland, dan Disney+. Alles bekijken voor de helft van de prijs.' },
				{ title: 'Gebruik je bibliotheekpas', body: 'De openbare bibliotheek geeft gratis toegang tot e-books, luisterboeken, films en tijdschriften via apps als OverDrive en PressReader.' },
				{ title: 'Annuleer na de gratis proefperiode', body: 'Zet een herinnering als je een gratis periode start. Vergeet je het, betaal je maandelijks voor iets wat je misschien niet nodig hebt.' },
			],
		},
		{
			icon: '🏥',
			title: 'Verzekeringen',
			saving: 'Bespaar €30–€150/mnd',
			color: '#059669',
			tips: [
				{ title: 'Verhoog je eigen risico zorgverzekering', body: 'Van €385 naar €885 eigen risico kan je premie €15–€25 per maand verlagen. Zinvol als je weinig zorgkosten verwacht.' },
				{ title: 'Vergelijk zorgverzekeringen via Zorgwijzer.nl', body: 'Overstappen in november/december. Zorgwijzer vergelijkt op prijs én dekking. Veel mensen betalen €20–€50/mnd te veel.' },
				{ title: 'Combineer verzekeringen bij één maatschappij', body: 'Pakketkorting bij één verzekeraar kan 5–15% zijn op al je polissen. Vraag je huidige verzekeraar om een totaalkorting.' },
				{ title: 'Controleer of je dubbel verzekerd bent', body: 'Rechtsbijstandsverzekering via de vakbond + zelf? Inboedel én huurdersverzekering bij je verhuurder? Dubbele verzekeringen zijn weggegooid geld.' },
				{ title: 'Betaal jaarlijks in plaats van maandelijks', body: 'Veel verzekeraars rekenen 3–5% toeslag voor maandelijkse betaling. Jaarlijks betalen bespaart dit direct.' },
			],
		},
	],
	en: [
		{
			icon: '🛒',
			title: 'Groceries',
			saving: 'Save €100–€250/mo',
			color: '#16a34a',
			tips: [
				{ title: 'Choose store brands', body: 'Albert Heijn house brand, Lidl or Aldi products cost 30–50% less than name brands. The quality difference is often minimal.' },
				{ title: 'Make a shopping list', body: 'Impulse purchases cost an average of €40–€80 extra per month. Plan your meals a week ahead and only write down what you need.' },
				{ title: 'Use Picnic or Crisp', body: 'Online grocery shopping prevents impulse purchases. Picnic and Crisp also offer low prices through their direct sourcing model.' },
				{ title: 'Buy seasonal fruit and vegetables', body: 'Seasonal produce is 2–3x cheaper than imported fruit or vegetables out of season.' },
				{ title: 'Check deals at Lidl and Aldi', body: 'The Lidl Plus app and Aldi app give extra discounts. Combining sale items can quickly save you 20–30%.' },
				{ title: 'Avoid pre-cut vegetables', body: 'A bag of sliced peppers can cost twice as much as a whole pepper. Small effort, big difference over a year.' },
			],
		},
		{
			icon: '👕',
			title: 'Clothing',
			saving: 'Save €50–€150/mo',
			color: '#7c3aed',
			tips: [
				{ title: 'Buy second-hand via Vinted or Marktplaats', body: 'Designer clothing at a fraction of the price. A Levi\'s jeans worth €100 can be found on Vinted for €15–€30.' },
				{ title: 'Use the 30-day rule', body: 'Want to buy something? Wait 30 days. If you still want it, buy it. This eliminates nearly all impulse purchases.' },
				{ title: 'Shop off-season', body: 'Winter coats in April, summer dresses in September — often 50–70% off in the end-of-season sales.' },
				{ title: 'Repair instead of throwing away', body: 'A cobbler costs €10–€20 and gives your shoes 2–3 extra years of life. Much cheaper than new shoes.' },
				{ title: 'Invest in quality basics', body: 'Spending €50 on a T-shirt that lasts 5 years is cheaper than buying a €15 one every year.' },
			],
		},
		{
			icon: '⚡',
			title: 'Energy contracts',
			saving: 'Save €50–€200/mo',
			color: '#d97706',
			tips: [
				{ title: 'Compare via Energie.nl or Gaslicht.com', body: 'Switching annually can save €200–€600 per year. Use comparison sites and lock in a contract when rates are low.' },
				{ title: 'Choose a variable contract when prices fall', body: 'When energy prices drop, you benefit immediately with a variable contract. Follow the market via Gaslicht.com.' },
				{ title: 'Lower the thermostat by 1°C', body: '1°C lower = ~6% less gas usage. Going from 21 to 19°C can save €15–€30 per month easily.' },
				{ title: 'LED lighting and efficient appliances', body: 'LED uses 80% less electricity than incandescent bulbs. An energy-label A washing machine vs. label D saves €60–€100 per year.' },
				{ title: 'Draught strips and insulation', body: 'Draught strips (€5–€15) and floor insulation can lower your gas bill by 10–15%. Payback time: just a few months.' },
				{ title: 'Get solar panels installed', body: 'Average payback time for solar panels is 7–9 years, then free electricity. Request quotes via comparison sites.' },
			],
		},
		{
			icon: '🏦',
			title: 'High-interest savings account',
			saving: 'Earn €50–€500/yr extra',
			color: '#0891b2',
			tips: [
				{ title: 'Compare via Raisin.nl', body: 'Raisin gives access to European savings accounts with higher rates. Think 2–3% interest while the big Dutch banks offer 0.5–1%.' },
				{ title: 'NIBC Direct or Bunq', body: 'NIBC Direct sometimes offers higher savings rates than ABN, ING or Rabobank. Bunq Easy Savings also consistently offers higher rates.' },
				{ title: 'Spread over multiple banks (DGS)', body: 'The Deposit Guarantee Scheme covers €100,000 per person per bank. Spread large amounts to always be covered.' },
				{ title: 'Use a savings account for your emergency fund', body: 'Keep 3–6 months of fixed expenses in a separate savings account. The interest helps your emergency fund grow slowly.' },
				{ title: 'Consider Scalable Capital and Trade Republic', body: 'Trade Republic offers 3–3.5% on uninvested cash — higher than most savings accounts and freely accessible.' },
			],
		},
		{
			icon: '📱',
			title: 'Phone & Internet',
			saving: 'Save €20–€80/mo',
			color: '#0284c7',
			tips: [
				{ title: 'Switch to a SIM-only plan', body: 'SIM-only plans start from €5/mo. If your phone works, why pay €35–€55 for a device plan?' },
				{ title: 'Compare via Bellen.com or Mobiel.nl', body: 'Comparison sites show you the best deal. Switching takes half an hour and can save €20/mo.' },
				{ title: 'Choose a low-cost provider', body: 'Ben, Simpel, Youfone and Lebara use the same masts as the big providers but are €10–€25 per month cheaper.' },
				{ title: 'Buy a refurbished phone', body: 'A refurbished iPhone from Renewd or Back Market costs 30–50% less than new, with warranty. Eco-friendly and cheaper.' },
				{ title: 'Bundle internet and TV', body: 'Providers often give discounts on bundle packages. Check Odido, Ziggo and KPN bundle deals — sometimes €15–€25 off per month.' },
			],
		},
		{
			icon: '🚗',
			title: 'Transport',
			saving: 'Save €50–€300/mo',
			color: '#dc2626',
			tips: [
				{ title: 'Share your car via SnappCar', body: 'A car that sits still costs money. Rent it via SnappCar when you don\'t use it and earn back €200–€500 per month.' },
				{ title: 'Cycle or use public transport for trips under 10 km', body: 'Driving a car including depreciation costs about €0.30–€0.40 per km. Cycling is free and keeps you fit.' },
				{ title: 'Carpool to work', body: 'Carpooling with one colleague halves your fuel costs. Easy to organize via BlaBlaCar or an internal company system.' },
				{ title: 'Compare car insurance annually', body: 'Via Independer or Pricewise you can save hundreds of euros a year by switching car insurance.' },
				{ title: 'Drive more economically', body: 'Ease off the accelerator, turn off the engine when stationary — this quickly saves 10–15% on fuel consumption.' },
			],
		},
		{
			icon: '📺',
			title: 'Subscriptions',
			saving: 'Save €30–€100/mo',
			color: '#9333ea',
			tips: [
				{ title: 'Do a subscription audit', body: 'Look at your bank statements from the last 3 months. Many people pay for subscriptions they barely use (gym, streaming, apps).' },
				{ title: 'Share accounts with family', body: 'Netflix, Spotify and Disney+ offer family plans. Splitting costs with household members or friends can save €5–€15/mo per person.' },
				{ title: 'Rotate streaming services', body: 'Do you really need every service at the same time? Take Netflix for 1–2 months, then Videoland, then Disney+. See everything for half the price.' },
				{ title: 'Use your library card', body: 'The public library gives free access to e-books, audiobooks, films and magazines via apps like OverDrive and PressReader.' },
				{ title: 'Cancel after free trial periods', body: 'Set a reminder when you start a free trial. If you forget, you\'ll pay monthly for something you may not need.' },
			],
		},
		{
			icon: '🏥',
			title: 'Insurance',
			saving: 'Save €30–€150/mo',
			color: '#059669',
			tips: [
				{ title: 'Raise your health insurance excess', body: 'Going from €385 to €885 excess can lower your premium by €15–€25 per month. Worth it if you expect low healthcare costs.' },
				{ title: 'Compare health insurance via Zorgwijzer.nl', body: 'Switch in November/December. Zorgwijzer compares on price AND coverage. Many people pay €20–€50/mo too much.' },
				{ title: 'Combine insurance at one provider', body: 'Package discounts with one insurer can be 5–15% on all your policies. Ask your current insurer for a total discount.' },
				{ title: 'Check if you\'re doubly insured', body: 'Legal aid insurance via union + your own? Contents insurance AND a tenant policy from your landlord? Double coverage is wasted money.' },
				{ title: 'Pay annually instead of monthly', body: 'Many insurers charge a 3–5% surcharge for monthly payment. Paying annually eliminates this directly.' },
			],
		},
	],
};

const SaveMoneyPage = ({ language }) => {
	const [expanded, setExpanded] = useState(false);
	const data = categories[language] || categories.nl;

	const totalSavingLabel = language === 'en'
		? 'Total potential savings'
		: 'Totale potentiële besparing';
	const perMonthLabel = language === 'en' ? '/mo' : '/mnd';
	const subtitleText = language === 'en'
		? 'Practical tips to lower your monthly expenses — so you have more left over to invest every month.'
		: 'Praktische tips om je maandlasten te verlagen — zodat je elke maand meer overhoudt om te beleggen.';

	return (
		<Box>
			<SEOHead
				title={language === 'en'
					? 'Ways to save money for early retirement | VisualiseermijnPensioen.nl'
					: 'Besparen voor vroegpensioen | VisualiseermijnPensioen.nl'}
				description={subtitleText}
				canonical="https://www.visualiseermijnpensioen.nl/besparen"
				lang={language === 'en' ? 'en' : 'nl'}
			/>
			<Typography variant="h5" fontWeight="bold" gutterBottom>
				{language === 'en' ? '💰 Ways to save money' : '💰 Manieren om te besparen'}
			</Typography>
			<Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
				{subtitleText}
			</Typography>
			<Chip
				label={`${totalSavingLabel}: €330–€1.280${perMonthLabel}`}
				sx={{ mb: 3, bgcolor: '#f0fdf4', color: '#15803d', fontWeight: 700, fontSize: 13, border: '1px solid #bbf7d0' }}
			/>

			{data.map((cat, i) => (
				<Accordion
					key={i}
					expanded={expanded === i}
					onChange={(_, open) => setExpanded(open ? i : false)}
					disableGutters
					elevation={0}
					sx={{
						mb: 1.5,
						border: '1px solid #e2e8f0',
						borderRadius: '12px !important',
						'&:before': { display: 'none' },
						overflow: 'hidden',
					}}
				>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						sx={{
							px: 2.5,
							py: 1,
							'&.Mui-expanded': { minHeight: 56 },
							bgcolor: expanded === i ? '#f8fafc' : 'white',
						}}
					>
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1, minWidth: 0 }}>
							<Typography fontSize={28} lineHeight={1}>{cat.icon}</Typography>
							<Box sx={{ flex: 1, minWidth: 0 }}>
								<Typography fontWeight={700} fontSize={15}>{cat.title}</Typography>
							</Box>
							<Chip
								label={cat.saving}
								size="small"
								sx={{
									bgcolor: cat.color + '15',
									color: cat.color,
									fontWeight: 700,
									fontSize: 11,
									border: `1px solid ${cat.color}30`,
									flexShrink: 0,
									mr: 1,
								}}
							/>
						</Box>
					</AccordionSummary>
					<AccordionDetails sx={{ px: 2.5, pt: 0, pb: 2 }}>
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
							{cat.tips.map((tip, j) => (
								<Box
									key={j}
									sx={{
										p: 2,
										bgcolor: '#f8fafc',
										borderRadius: 2,
										borderLeft: `3px solid ${cat.color}`,
									}}
								>
									<Typography fontWeight={700} fontSize={14} gutterBottom>
										{tip.title}
									</Typography>
									<Typography variant="body2" color="text.secondary" lineHeight={1.6}>
										{tip.body}
									</Typography>
								</Box>
							))}
						</Box>
					</AccordionDetails>
				</Accordion>
			))}

			<Typography variant="caption" color="text.disabled" sx={{ mt: 2, display: 'block' }}>
				{language === 'en'
					? '* Savings estimates are indicative and depend on your personal situation.'
					: '* Bespaarbedragen zijn indicatief en afhankelijk van je persoonlijke situatie.'}
			</Typography>
		</Box>
	);
};

export default SaveMoneyPage;
